<div class="contian pb-2">
    <div class="table-head mb-0 d-flex justify-content-between align-items-center" *ngIf="isDepartment">
        {{'all-services.dept-name' | translate}}</div>
    <div class="table-head mb-0 d-flex justify-content-between align-items-center" *ngIf="!isDepartment">{{'dashboard.serviceName' | translate}}
       </div>

    <ul class="dept-srv-table p-0 m-0 custom-scroll">
        <ng-container *ngIf="isDepartment; else service;">
            <li class="dept-srv-table__row d-flex" *ngFor="let item of deptResp | slice: 0:10;let i=index">
                <div class="dept-srv-table__col w-100">
                    <p class="mb-0">{{i+1}}. {{item?.deptname?item?.deptname:'N/A'}}</p>
                </div>
            </li>
        </ng-container>
        <ng-template #service>
            <li class="dept-srv-table__row d-flex" *ngFor="let item of serviceResp | slice: 0:10;let i=index">
                <div class="dept-srv-table__col w-100">
                    <p class="mb-0">{{i+1}}. {{item?.servname?item?.servname:'N/A'}}</p>
                </div>
            </li>
        </ng-template>
    </ul>
</div>